import React, { createContext, useContext, useState } from "react"

const HeaderContext = createContext()

export const HeaderProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false)
  const [openDropdown, setOpenDropdown] = useState("")
  const [childOpenState, setChildOpenState] = useState("")
  const [subChildOpenState, setSubChildOpenState] = useState("")
  const [childClicked, setChildClicked] = useState(false)

  const handleLinkClick = () => {
    setIsOpen(false)
    setOpenDropdown("")
    setChildOpenState("")
    setSubChildOpenState("")
    setChildClicked(false)
  }

  return (
    <HeaderContext.Provider
      value={{
        isOpen,
        setIsOpen,
        openDropdown,
        setOpenDropdown,
        childOpenState,
        setChildOpenState,
        subChildOpenState,
        setSubChildOpenState,
        childClicked,
        setChildClicked,
        handleLinkClick,
      }}
    >
      {children}
    </HeaderContext.Provider>
  )
}

export const useHeaderContext = () => {
  return useContext(HeaderContext)
}
